
































































































import Vue from "vue";
import { createNamespacedHelpers } from "vuex";

const { mapActions: reportsActions, mapGetters: reportsGetters } =
  createNamespacedHelpers("reports");
import ReportDateFilter from "./ReportDateFilter.vue";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default Vue.extend<any, any, any, any>({
  components: {
    ReportDateFilter,
  },
  name: "PaymentReportList",
  data: () => ({
    headers: [
      { text: "Type", value: "report_name", sortable: false },
      { text: "Amount", value: "value", sortable: false },
      { text: "Count", value: "count", sortable: false },
      { text: "actions", value: "actions", sortable: false },
    ],
    startDate: null as string | null,
    endDate: null as string | null,
    applyDateFilter: true,
    filterStart: null as string | null,
    filterEnd: null as string | null,
  }),
  computed: {
    ...reportsGetters(["paymentReports", "loading", "error"]),
  },
  watch: {
    applyDateFilter(x: boolean) {
      if (!x) {
        this.startDate = null;
        this.endDate = null;
      } else {
        this.startDate = this.filterStart;
        this.endDate = this.filterEnd;
      }
    },
    startDate() {
      this.fetchPaymentsData();
    },
    endDate() {
      this.fetchPaymentsData();
    },
  },
  methods: {
    ...reportsActions(["fetchPaymentReports"]),
    onRangeChange(filters: { start: string; end: string }) {
      this.filterStart = filters.start;
      this.filterEnd = filters.end;

      if (this.applyDateFilter) {
        this.startDate = filters.start;
        this.endDate = filters.end;
      }
    },
    async fetchPaymentsData() {
      try {
        await this.fetchPaymentReports({
          startDate: this.startDate,
          endDate: this.endDate,
        });
      } catch (error) {
        console.error("Failed to fetch payment reports:", error);
      }
    },
    clear() {
      this.startDate = null;
      this.endDate = null;
    },
    navigate(item: { report_name: string }) {
      const query: Record<string, string> = {
        tab: "orders",
        method: item.report_name,
      };

      if (this.startDate) {
        const date = new Date(this.startDate);
        date.setHours(0, 0, 0, 0);
        query.startDate = date.toISOString();
      }
      if (this.endDate) {
        const date = new Date(this.endDate);
        date.setHours(23, 59, 59, 59);
        query.endDate = date.toISOString();
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (this as any).$router.push({
        path: "/reports/report-detail",
        query,
      });
    },
    getPaymentIcon(paymentMethod: string): string {
      const iconMap: Record<string, string> = {
        "m-pesa": "mdi-cellphone",
        cash: "mdi-cash",
        card: "mdi-credit-card",
        membership: "mdi-account-star",
        voucher: "mdi-ticket-percent",
        Unknown: "mdi-help-circle",
      };
      return iconMap[paymentMethod] || "mdi-credit-card-outline";
    },
    getPaymentIconColor(paymentMethod: string): string {
      const colorMap: Record<string, string> = {
        "m-pesa": "green",
        cash: "orange",
        card: "blue",
        membership: "purple",
        voucher: "red",
        Unknown: "grey",
      };
      return colorMap[paymentMethod] || "grey";
    },
    formatPaymentMethod(method: string): string {
      if (method === "m-pesa") return "M-Pesa";
      if (method === "Unknown") return "Unknown Payment";
      return method.charAt(0).toUpperCase() + method.slice(1);
    },
    getValueChipColor(value: number): string {
      if (value >= 100000) return "green";
      if (value >= 50000) return "blue";
      if (value >= 10000) return "orange";
      return "grey";
    },
  },

  mounted() {
    this.fetchPaymentsData();
  },
});
